<template>
  <div class="publications-wrap pt-20 pb-20">
    <div class="container mx-auto px-4">
      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
        Publications
      </h2>

      <!-- Liste des publications -->
      <div class="content-text max-w-4xl mx-auto text-gray-800 leading-relaxed">
        <ul class="list-disc ps-4">
          <li class="mb-2">
            GBEDJINOU R., <em>Enfants du Bénin, debout ! Hymne national commenté</em>, Les Editions IdS, Cotonou 2020, 11×18, 105 p., ISBN 978-99982-934-3-4
          </li>
          <li class="mb-2">
            AÏFAN M., <em>Aujourd’hui encore, Jésus guérit et sauve. Les conditions du miracle à la lumière de Ac 9, 32-43</em>, Les Editions IdS, Cotonou 2019, 11×18, 106 p., ISBN 978-99982-912-9-4
          </li>
          <li class="mb-2">
            HOUNMENOU M., <em>L’ésotérisme et la foi chrétienne : les raisons d’une incompatibilité</em>, Les Editions IdS, Cotonou 2019, 10,5×17, 190 p., ISBN 978-99982-912-2-5
          </li>
          <li class="mb-2">
            TECHOU R., <em>Christianité du Christianisme. Essai sur l’Être Chrétien</em>, Les Editions du Philosophât, Collection Penser et croire, Cotonou 2019, 13×20, 196 p., ISBN 978-99919-79-56-4
          </li>
          <li class="mb-2">
            AÏFAN M., <em>Lumière sur les passages difficiles de la Bible. Tome 1</em>, Les Editions IdS, Cotonou 2018, 15×21, 126 p., ISBN 978-99919-79-00-7
          </li>
          <li class="mb-2">
            GBEDJINOU R., <em>Sauvons l’esprit de la conférence nationale. Le défi pour aujourd’hui et demain</em>, Les Editions IdS, Cotonou 2018, 11×18, 70 p., ISBN 978-99919-804-7-8
          </li>
          <li class="mb-2">
            GBEDJINOU R., <em>Jeunes, osez ! C’est le moment</em>, Les Editions IdS, Cotonou 2018, 11×18, 140 p., ISBN 978-99919-77-16-4
          </li>
          <li class="mb-2">
            GBEDJINOU R., <em>Se libérer de la peur</em>, Les Editions IdS, Cotonou 2018, 11×18, 67 p., ISBN 978-99919-79-01-4
          </li>
          <li class="mb-2">
            HOUNMENOU M., <em>Peut-on danser à la messe ? Recherches sur le sens et la spécificité des célébrations chrétiennes</em>, Les Editions IdS, Cotonou 2017, 15×21, 164 p., ISBN 978-99919-804-1-6
          </li>
          <li class="mb-2">
            GOUDJINOU C., <em>Être chrétien, une chance pour l’humanité. Du réalisme de la foi, l’engagement citoyen du chrétien</em>, Les Editions du Chant d’Oiseau, Cotonou 2016, ISBN 978-99919-64-39-3
          </li>
          <li class="mb-2">
            GBEDJINOU R., <em>Et pourtant, j’ai la Foi. La foi face aux épreuves de la vie</em>, Les Editions IdS, Cotonou 2013, 11×18, 82 p., ISBN 978-99919-1-453-4
          </li>
        </ul>

        <!-- Pagination (optionnel) -->
        <div class="mt-6 flex justify-center">
          <button class="mx-1 px-3 py-1 border rounded text-gray-700 hover:bg-yellow-100">‹</button>
          <button class="mx-1 px-3 py-1 border rounded text-gray-700 bg-yellow-200">1</button>
          <button class="mx-1 px-3 py-1 border rounded text-gray-700">2</button>
          <button class="mx-1 px-3 py-1 border rounded text-gray-700 hover:bg-yellow-100">›</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PubliCation", 
  setup() {
    return {};
  },
});
</script>

<style scoped>
.publications-wrap {
  background-color: #fff;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

h2 {
  color: #2b3a67;
}

.content-text ul {
  line-height: 1.8;
  padding-left: 1.5rem;
}

.content-text li {
  margin-bottom: 0.75rem;
}

button {
  transition: 0.3s;
}
</style>
